import React from 'react';
import './PrivacyPolicyPage.css';

function PrivacyPolicyPageZhLite() {
    return (
        <div className="privacy-policy-container">
      <h1>塔斯比赫·迪克尔轻应用隐私政策</h1>
      <p>最后更新：2024年1月31日</p>

      <h2>引言</h2>
      <p>欢迎使用塔斯比赫·迪克尔轻应用。本隐私政策旨在告知您在使用我们的应用时我们如何处理您的数据。此应用中唯一的数据收集是通过Google的广告服务AdMob进行的，我们不主动收集任何个人数据。</p>

      <h2>1. 收集和使用您的个人数据</h2>
      <h3>a. 收集的数据类型</h3>
      <h4>i. 通过AdMob使用数据</h4>
      <p>我们的应用使用AdMob来展示广告。AdMob可能会收集诸如您的IP地址、设备标识符以及您对应用的使用信息等数据。这些信息用于提供和改善广告体验。</p>

      <h3>b. 数据使用</h3>
      <p>AdMob收集的数据用于：</p>
      <ul>
        <li>在应用内提供和个性化广告。</li>
        <li>分析展示广告的效果。</li>
      </ul>

      <h3>c. 用户控制</h3>
      <p>您可以通过设备设置控制您的数据用于个性化广告的使用。</p>

      <h2>2. 数据传输</h2>
      <p>您的信息可能会被传输并存储在您所在国家、省份或国家之外的计算机上，那里的数据保护法可能与您的地区不同。</p>

      <h2>3. 个人数据的披露</h2>
      <p>AdMob收集的数据可能会根据Google的隐私政策和法律要求进行共享。</p>

      <h2>4. 个人数据的安全</h2>
      <p>您的数据安全对我们至关重要。然而，任何通过互联网传输或电子存储的方法都不是100%安全的。</p>

      <h2>5. 链接到其他网站</h2>
      <p>我们的服务可能包含指向其他网站的链接。如果您点击第三方链接，您将被引导到该第三方的网站。</p>

      <h2>6. 本隐私政策的更改</h2>
      <p>我们可能会不时更新我们的隐私政策。我们将通过在本页面上发布新的隐私政策来通知您任何更改。</p>

      <h2>7. 联系我们</h2>
      <p>如果您对本隐私政策有任何疑问，请联系我们。</p>

      <h2>有用的链接</h2>
      <p><a href="https://policies.google.com/privacy">Google隐私政策</a></p>
    </div>
    );
}

export default PrivacyPolicyPageZhLite;
